import { render, staticRenderFns } from "./datto-autotask-page.vue?vue&type=template&id=cca2f69c&"
import script from "./datto-autotask-page.vue?vue&type=script&lang=tsx&"
export * from "./datto-autotask-page.vue?vue&type=script&lang=tsx&"
import style0 from "./datto-autotask-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports